import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from './login.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationService } from './notification.service';

// Requisições com este cabeçalho não exibem notificação de erro; quem chama trata a falha.
export const HEADER_REQUISICAO_SILENCIOSA = 'X-Requisicao-Silenciosa';

@Injectable({ providedIn: 'root' })
export class ErrorHttpInterceptor implements HttpInterceptor {
    
    constructor(
        private notification: NotificationService,
        private ngZone: NgZone,
        private router: Router,
        private loginService: LoginService
    ) { }
    
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const silenciosa = req.headers.has(HEADER_REQUISICAO_SILENCIOSA);
        if (silenciosa) {
            req = req.clone({ headers: req.headers.delete(HEADER_REQUISICAO_SILENCIOSA) });
        }

        return next
            .handle(req)
            .pipe(
                catchError(retorno => {
                    if (retorno instanceof HttpErrorResponse) {
                        this.ngZone.run(() => {
                            if (retorno.status === 401) {
                                this.loginService.logout();
                            }
                            else if (silenciosa) {
                                return;
                            }
                            else if(retorno.error){
                                if (retorno.error.erros instanceof Array) {
                                    this.notification.openErrorMultiLine(retorno.error.erros);
                                }
                                else if (retorno.error instanceof ProgressEvent) {
                                    this.notification.openError('Não foi possível completar a ação, por favor tente novamente mais tarde.');
                                }
                                else if (typeof (retorno.error) === 'string') {
                                    const erroStr = retorno.error.length > 200 ? retorno.error.substring(0, 200) : retorno.error
                                    this.notification.openError(erroStr);
                                }
                            }
                            else{
                                this.notification.openError('Não foi possível completar a ação, por favor tente novamente mais tarde.');
                            }
                        });
                    }
                    throw retorno;
                })
            );
    }
}
